
import { Types } from 'app/actions/company-admin/page-offline-donations';
import utils from 'app/reducers/utils';

const initialState = {
  offlineDonationIds: null,
  pagination: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.SEARCH}_PENDING`]: (state, _action) => {
    return {...state,
      offlineDonationIds: null,
      pagination: null,
      loadPending: true,
    };
  },
  [`${Types.SEARCH}_RESOLVED`]: (state, {result: {offlineDonations, pagination}}) => {
    return {...state,
      offlineDonationIds: offlineDonations.map(od => od.id),
      pagination,
      loadPending: false,
    };
  },
  [`${Types.SEARCH}_REJECTED`]: (state, {error}) => {
    return {...state,
      offlineDonationIds: null,
      pagination: null,
      loadPending: false,
    };
  },

});

export default reducer;
